import React, { useState, useEffect } from 'react';
import { Button, Row, Col, Container, Modal, Form } from 'react-bootstrap';
import AddContacts from './AddContacts';
import Contacts from './Contacts';
import Test_Contact from './test_contact';
import { ImportContact } from '../../../helpers/api';
import PageTitle from '../../../components/PageTitle';

export const ContactManagement: React.FC = () => {
  const [showAddForm, setShowAddForm] = useState<boolean>(false);
  const [showImportModal, setShowImportModal] = useState<boolean>(false);
  const [groupName, setGroupName] = useState<string>('');
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isImporting, setIsImporting] = useState<boolean>(false);
  const [importError, setImportError] = useState<string | null>(null);
  const [alertMsg, setAlertMsg] = useState<string | null>(null);
  const [alertVariant, setAlertVariant] = useState<'success' | 'danger'>('success');

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
    }
  };
  useEffect(() => {
    if (!alertMsg) return;
    const timer = setTimeout(() => setAlertMsg(null), 3000);
    return () => clearTimeout(timer);
  }, [alertMsg]);


  const handleImport = async () => {
    if (!selectedFile) {
      setImportError('Please select a file to import');
      return;
    }

    setIsImporting(true);
    setImportError(null);

    try {
      const formData = new FormData();
      if (selectedFile) formData.append('file', selectedFile);
      if (groupName) formData.append('group_name', groupName);

      const response = await ImportContact(formData);
      // console.log('Import successful:', response.data);
      setShowImportModal(false);
      setGroupName('');
      setSelectedFile(null);
    } catch (error: any) {
      console.error('Import failed:', error);
      setImportError(error.response?.data?.message || 'Failed to import contacts');
    } finally {
      setIsImporting(false);
    }
  };

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: 'Contacts', path: '/Contacts' },
          { label: 'Contacts', path: '/Apps/Contacts', active: true },
        ]}
        title="Contacts"
      />
      {alertMsg && (
        <div className={`alert alert-${alertVariant}`} role="alert">
          {alertMsg}
        </div>
      )}

      {/* <Container className="contact-management py-4 px-3 px-md-4 px-lg-5 "> */}
      <Row className="mb-2 align-items-end">

        {/* Left side – Import */}
        {/* <Col className="d-flex justify-content-end">
          
        </Col> */}

        {/* Right side – Add / View */}
        <Col className="d-flex justify-content-end gap-2">
          <Button
            variant="secondary"
            className="d-flex align-items-center "
            onClick={() => setShowImportModal(true)}
          ><i className="bi bi-file-earmark-arrow-up fs-5 fw-bold"></i>
            Import Contacts
          </Button>
          <Button
            variant={showAddForm ? "outline-primary" : "primary"}
            onClick={() => setShowAddForm(!showAddForm)}
            className="d-flex align-items-center btn-sm"
          >
            {showAddForm ? (
              <>
                <i className="mdi mdi-format-list-bulleted fs-5 fw-bold"></i>
                View Contacts
              </>
            ) : (
              <> <i className="bi bi-person-plus fs-5 fw-bold"> </i> New Contact</>
            )}
          </Button>
        </Col>

      </Row>


      <Row>
        <Col>
          <div>
            <Test_Contact
              onSuccess={(msg) => {
                setAlertVariant("success");
                setAlertMsg(msg);
              }}
              onError={(msg) => {
                setAlertVariant("danger");
                setAlertMsg(msg);
              }}
            />
            {/* {showAddForm ? <AddContacts /> : <Test_Contact />} */}
            {/* {showAddForm ? <AddContacts /> : <Contacts />} */}
          </div>
        </Col>
      </Row>

      <Modal show={showImportModal} onHide={() => setShowImportModal(false)}>
        <Modal.Header style={{ background: 'linear-gradient(135deg, #0eb7eb, #167491)' }} >
          <Modal.Title className='text-white'>Import Contacts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Upload File</Form.Label>
              <Form.Control
                type="file"
                onChange={handleFileChange}
                accept=".csv,.xlsx,.xls"
              />
              <Form.Text className="text-muted">
                Supported formats: CSV, Excel
              </Form.Text>

              <div className="mt-2">
                <a
                  href="http://api.skynyx.ai/file_storage/Contacts.csv"
                  download
                  className="btn btn-primary btn-sm"
                >
                  Download Sample File
                </a>
              </div>
            </Form.Group>


            <Form.Group controlId="formGroupName" className="mb-3">
              <Form.Label>Group Name (Optional)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter group name"
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
              />
            </Form.Group>
            {importError && <div className="text-danger mb-3">{importError}</div>}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowImportModal(false)}>
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handleImport}
            disabled={isImporting || !selectedFile}
          >
            {isImporting ? 'Importing...' : 'Import'}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showAddForm}
        onHide={() => setShowAddForm(false)}
        size="lg"
      // centered
      >
        <Modal.Header className="d-flex justify-content-between align-items-center" style={{ background: 'linear-gradient(135deg, #0eb7eb, #167491)' }} >
          <Modal.Title className="text-white">Add New Contact</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <AddContacts
            onClose={() => setShowAddForm(false)}
            onSuccess={() => {
              setAlertVariant('success');
              setAlertMsg('Contact added successfully');
              setShowAddForm(false);
            }}
          />

        </Modal.Body>
      </Modal>

      {/* </Container> */}
    </>
  );
};